import ReviewRatingFeedback from './ReviewRatingFeedback';

export default ReviewRatingFeedback;
